export default {
  path: '/packing',
  name: 'Packing',
  meta: {
    title: '包装',
    showTabBar: true
  },
  redirect: {
    name: 'PackingList'
  },
  component: () => import('@/views/layout/HomeLayout'),
  children: [
    {
      path: 'packing-list',
      name: 'PackingList',
      meta: {
        title: '包装管理',
        showTabBar: true
      },
      component: () => import('@/views/packing/Packing')
    },
    {
      path: 'trace-packing',
      name: 'TracePacking',
      meta: {
        title: '查看溯源',
        showTabBar: false
      },
      props: route => ({
        traceCode: route.query.traceCode
      }),
      component: () => import('@/views/packing/TracePacking')
    },
    {
      path: 'trace-packing-edit',
      name: 'TracePackingEdit',
      meta: {
        title: '编辑溯源',
        showTabBar: false
      },
      props: route => ({
        traceCode: route.query.traceCode
      }),
      component: () => import('@/views/packing/TracePackingEdit')
    }
  ]
}

